import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';

export default function PermanentDeleteModal({ open, onClose, onConfirm, item, itemType }) {
  const [inputValue, setInputValue] = useState('');
  const [isConfirmed, setIsConfirmed] = useState(false);

  // Reseta o input quando o modal é aberto ou o item muda
  useEffect(() => {
    if (open) {
      setInputValue('');
    }
  }, [open]);

  // Define o texto de confirmação e verifica a correspondência
  useEffect(() => {
    let confirmationText = '';
    if (itemType === 'company' && item?.slug) {
      confirmationText = item.slug;
    } else if (itemType === 'user' && item?.email) {
      confirmationText = item.email;
    }

    if (confirmationText) {
      setIsConfirmed(inputValue === confirmationText);
    } else {
      setIsConfirmed(false);
    }
  }, [inputValue, item, itemType]);

  if (!open || !item) return null;

  const itemName = item.name || item.fullName;
  const confirmationText = itemType === 'company' ? item.slug : item.email;
  const typeName = itemType === 'company' ? 'a empresa' : 'o usuário';

  return (
    <div className="edit-modal-overlay" onClick={onClose}>
      <div
        className="edit-modal card"
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: '500px' }}
      >
        <div className="card-body">
          <div className="modal-header">
            <h3>Exclusão Permanente</h3>
            <button onClick={onClose} className="btn btn-secondary">
              ✕
            </button>
          </div>

          <div className="modal-content">
            <p>
              Esta ação é <strong>irreversível</strong> e excluirá permanentemente {typeName}{' '}
              <strong>{itemName}</strong>.
            </p>
            <p className="modal-tip">
              Para confirmar, digite <strong>{confirmationText}</strong> no campo abaixo.
            </p>
            <TextField
              fullWidth
              variant="outlined"
              value={inputValue}
              onChange={e => setInputValue(e.target.value)}
              placeholder={`Digite "${confirmationText}"`}
              autoFocus
            />
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn btn-secondary">
              Cancelar
            </button>
            <button
              type="button"
              onClick={() => onConfirm(item)}
              className="btn btn-danger"
              disabled={!isConfirmed}
            >
              Excluir Permanentemente
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
